<template>
  <div class="ArchiveTableDropdown">
    <VDropdown :distance="6" placement="right">
      <span class="ArchiveTableDropdown__button">
        <i class="fa fa-ellipsis-h" />
      </span>

      <template #popper>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <router-link v-if="toView" :to="toView" class="dropdown-item">
            {{ t('shared.actions.view') }}
          </router-link>
          <router-link v-if="toReview" :to="toReview" class="dropdown-item">
            {{ t('shared.actions.review') }}
          </router-link>
          <div v-if="toCustomTitle">
            <router-link v-if="toCustom" :to="toCustom" class="dropdown-item">
              {{ toCustomTitle }}
            </router-link>
            <a
              v-else
              class="dropdown-item"
              href="#"
              @click="$emit('custom', resource.id)"
              >{{ toCustomTitle }}</a
            >
          </div>

          <router-link v-if="toEdit" :to="toEdit" class="dropdown-item">
            {{ t('shared.actions.edit') }}
          </router-link>
          <div v-if="!deleteDisabled">
            <router-link v-if="toDelete" :to="toDelete" class="dropdown-item">
              {{ t('shared.actions.delete') }}
            </router-link>
            <a
              v-else
              class="dropdown-item"
              href="#"
              @click="$emit('delete', resource.id)"
              >{{ t('shared.actions.delete') }}</a
            >
          </div>
        </div>
      </template>
    </VDropdown>
  </div>
</template>

<script>
import './style.scss'
import { Dropdown as VDropdown } from 'floating-vue'

export default {
  name: 'ArchiveTableDropdown',
  components: { VDropdown },
  emits: ['custom', 'delete'],
  props: {
    toCustom: { type: Object },
    toCustomTitle: { type: String },
    toReview: { type: Object },
    toView: { type: Object },
    toEdit: { type: Object },
    toDelete: { type: Object },
    resource: { type: Object },
    deleteDisabled: { type: Boolean, default: false },
  },
}
</script>
